import {
	FASTSHIFT_RUNBOOK_STEP_STATUS,
	FastshiftRunbookStep,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

export type RunbookStepPhaseGroup = {
	phase: string;
	steps: FastshiftRunbookStep[];
};

const getStepPhase = (step: FastshiftRunbookStep, fallbackPhase: string) => {
	const phase = step.phase.trim();

	return phase || fallbackPhase;
};

export const groupRunbookStepsByPhase = (
	steps: FastshiftRunbookStep[],
	fallbackPhase: string,
): RunbookStepPhaseGroup[] => {
	const sortedSteps = [...steps].sort(
		(firstStep, secondStep) => firstStep.stepOrder - secondStep.stepOrder,
	);

	return sortedSteps.reduce<RunbookStepPhaseGroup[]>((groups, step) => {
		const phase = getStepPhase(step, fallbackPhase);
		const existingGroup = groups.find((group) => group.phase === phase);

		if (existingGroup) {
			existingGroup.steps.push(step);
		} else {
			groups.push({ phase, steps: [step] });
		}

		return groups;
	}, []);
};

export const isRunbookStepDone = (step: FastshiftRunbookStep) =>
	step.status === FASTSHIFT_RUNBOOK_STEP_STATUS.DONE;
